import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { getAdminToken, removeAdminToken } from '../utils/adminAuth';

/**
 * Admin access via role on the signed in user, or legacy session admin token.
 */
export function useAdminAuth() {
  const { user, token, isAuthenticated, loading, logout, refreshUser } = useAuth();

  const hasLegacyAdmin = Boolean(getAdminToken());
  const isRoleAdmin = isAuthenticated && user?.role === 'admin';
  const hasAdminAccess = hasLegacyAdmin || isRoleAdmin;

  const getAuthHeader = useCallback(() => {
    const legacyToken = getAdminToken();
    if (legacyToken) {
      return `Bearer ${legacyToken}`;
    }
    if (isRoleAdmin && token) {
      return `Bearer ${token}`;
    }
    return null;
  }, [isRoleAdmin, token]);

  return {
    user,
    token,
    loading,
    logout,
    refreshUser,
    hasLegacyAdmin,
    isRoleAdmin,
    hasAdminAccess,
    getAuthHeader,
    removeLegacyAdminToken: removeAdminToken,
  };
}
